import { ExtendedAddress } from "@model/address";
import { Profile } from "@model/users/profile";
import { User } from "@model/users/user";

/**
 * 
 * @param {string} profile cadena en formato groupId#businessId
 */
export function parseProfile(profile: string): Profile {
    const [groupId, businessId] = profile.split("#");
    return { groupId, businessId: businessId ?? null };
}

export function toProfile(groupId: string, businessId: string): string {
    return `${groupId}#${businessId}`;
}

/**
   * 
   * @param backUser 
   * @param ondemand 
   * @return {string[]}
   */
export function extractProfiles(backUser: User, ondemand?: boolean): string[] {
    return ondemand ? (backUser.ondemand ?? []) : backUser.profiles;
}

export function extendedAddressToString(address: ExtendedAddress): string {
    const buffer: string[] = [];

    buffer.push(address.addressLine1);

    if (address.no) {
        buffer.push(address.no);
    }

    if (address.apt) {
        buffer.push(`apto. ${address.apt}`);
    }

    if (address.addressLine2) {
        buffer.push(`esq. ${address.addressLine2}`);
    }

    if (address.obs) {
        buffer.push(`[${address.obs}]`);
    }

    if (address.neighborhood) {
        buffer.push(`,${address.neighborhood}`);
    }

    if (address.city) {
        buffer.push(`,${address.city}`);
    }

    return buffer.join(' ');
}